/**
 * Context-tagged error log for the sign-in hooks, which call it as
 * `(label, error)`.
 *
 * Only non-PII scalars are recorded. An `AuthError` (and the adapter's
 * `PasskeyError`) keeps the originating failure on `cause`, and Sentry's
 * linkedErrors integration walks cause chains into telemetry, so the error
 * object itself is never passed through - just the fields that identify what
 * went wrong.
 *
 * A `status` of 0 is the auth client's marker for a request that never got an
 * HTTP response (offline, blocked, aborted); the sign-in UI already reports it
 * and Sentry captures `console.error`, so it is not logged.
 */
export function logAuthError(label: string, error?: unknown): void {
  if (error === undefined) {
    console.error(label);
    return;
  }
  const { name, code, status } = (error ?? {}) as {
    name?: unknown;
    code?: unknown;
    status?: unknown;
  };
  if (status === 0) {
    return;
  }
  console.error(label, { name, code, status });
}
